import { stringifyGraph } from '@/clients/http'
import { OrderModel as OrderApi } from '@/http/models/Order/Order'
import { toast } from 'sonner'

import { useCallback, useState } from 'react'

import { OrderModel } from '@/types/model/Order'

export const useFetchOrder = () => {
  const [order, setOrder] = useState<OrderModel.Order | null>(null)
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState<string | null>(null)

  const fetchOrder = useCallback(async (id: string) => {
    if (!id) return

    setIsLoading(true)
    setError(null)

    try {
      const response = await OrderApi.getById({
        params: { id },
        query: {
          graph_enc: stringifyGraph({
            '*': true,
            order_note_id: { '*': true },
            order_source_id: { '*': true },
            order_items: { '*': true },
            order_logs: { '*': true },
            items: { '*': true },
            logs: { '*': true },
            returns: { '*': true, items: { '*': true } },
            delivery_location_type_id: { '*': true },
            deliveryMethod: { '*': true },
          }),
        },
      })

      if (!response.success || !response.data?.result) {
        throw new Error(response.error?.data?.message || 'Failed to fetch order')
      }

      setOrder(response.data.result)
      return response.data.result
    } catch (err: any) {
      const message = err.message || 'Failed to load order'
      setError(message)
      toast.error(message)
      return null
    } finally {
      setIsLoading(false)
    }
  }, [])

  return {
    order,
    isLoading,
    error,
    fetchOrder,
    setOrder,
  }
}
